
































import Vue from 'vue';
import AppMain from '@/components/AppMain.vue';
import AppForm from '@/components/AppForm.vue';
import PICKUPS from '@/graphql/queries/PickupLocations.graphql';
import PICKUP_ADD from '@/graphql/mutations/PickupAdd.graphql';
import { required } from 'vuelidate/lib/validators';
import validationMessages from '@/utils/validationMessages';
import { PickupLocation, PickupAddMutationVariables } from '@/types/schema';
import { GraphQLError } from 'graphql';

export default Vue.extend({
  name: 'DriverRoutePickupAdd',
  components: {
    AppMain,
    AppForm,
  },
  data() {
    return {
      loading: false,
      errors: [] as GraphQLError[],
      form: {
        location: '',
      },
      pickups: [] as PickupLocation[],
    };
  },
  validations() {
    return {
      form: {
        location: { required },
      },
    };
  },
  methods: {
    validationMessages,
    async addPickup() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        this.loading = true;
        this.errors = [];
        await this.$apollo.mutate({
          mutation: PICKUP_ADD,
          variables: {
            input: {
              routeId: this.$route.params.id,
              locationId: this.form.location,
            },
          } as PickupAddMutationVariables,
        });
        this.$router.push({
          name: 'driver-route',
          params: { id: this.$route.params.id },
        });
      } catch ({ graphQLErrors }) {
        this.errors = graphQLErrors;
      } finally {
        this.loading = false;
      }
    },
  },
  apollo: {
    pickups: {
      query: PICKUPS,
    },
  },
});
